import React, { useState } from 'react';
import { ResumeData } from '../../../../../types/resume';
import { templates } from '../../../templates';
import { ChevronDown, ChevronUp, Check } from 'lucide-react';

interface Props {
  data: ResumeData;
  onUpdate: (data: Partial<ResumeData>) => void;
}

export default function TemplateForm({ data, onUpdate }: Props) {
  const [expandedTemplate, setExpandedTemplate] = useState<string | null>(data.template);

  const handleTemplateSelect = (templateId: string) => {
    onUpdate({ template: templateId });
    setExpandedTemplate(templateId);
  };

  return (
    <div className="space-y-8">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="text-2xl font-bold text-gray-900">Choose Your Template</h2>
        <p className="mt-2 text-gray-600">
          Select a template that best presents your information. Each template is professionally designed
          and ATS-friendly.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {templates.map((template) => {
          const isSelected = data.template === template.id;
          const Component = template.component;

          return (
            <div
              key={template.id}
              className={`
                bg-white rounded-lg border-2 transition-all cursor-pointer
                ${isSelected 
                  ? 'border-teal-500 shadow-md' 
                  : 'border-gray-200 hover:border-teal-300'}
              `}
              onClick={() => handleTemplateSelect(template.id)}
            >
              <div className="p-4">
                <div className="flex items-center gap-4">
                  {isSelected && (
                    <div className="flex-shrink-0 w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center">
                      <Check className="h-4 w-4 text-white" />
                    </div>
                  )}
                  <div className="text-left">
                    <h3 className="font-medium text-gray-900">{template.name}</h3>
                    <p className="text-sm text-gray-500">{template.description}</p>
                  </div>
                </div>
              </div>
              <div className="border-t border-gray-100 p-4 bg-gray-50">
                <div className="bg-white shadow-sm mx-auto h-[200px] overflow-hidden">
                  <Component data={data} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}